export const MAX_NAV_LINKS_BEFORE_3XL = 6;
export const MAX_NAV_LINKS = 8;
